import { Transfer } from 'antd';
import { Form } from '@bancobarigui/barihaus';

import { useRoleTransfer } from './useRoleTransfer';
import { RoleModuleType } from '@/shared/enums/RoleModuleType';

type Props = {
  module: RoleModuleType;
};

export function RoleTransfer({ module }: Props) {
  const { roles } = useRoleTransfer({ module });

  return (
    <>
      <style>{`
        .role-transfer .ant-transfer-list {
          border-radius: 8px !important;
          border-color: #d6dbe7 !important;
        }
        .role-transfer .ant-transfer-list-search .ant-input,
        .role-transfer .ant-transfer-list-search.ant-input-affix-wrapper {
          border-radius: 8px !important;
          border-color: #d6dbe7 !important;
        }
      `}</style>
      <Form.Item
        name="roles"
        valuePropName="targetKeys"
        getValueFromEvent={(targetKeys) => targetKeys}
        rules={[{ required: true, message: 'Informe ao menos um Perfil.' }]}
      >
        <Transfer
          className="role-transfer"
          listStyle={{
            width: '50%',
            height: 300,
          }}
          dataSource={roles}
          render={(item) => item.title ?? ''}
          titles={['Perfis Disponíveis', 'Perfis Selecionados']}
        />
      </Form.Item>
    </>
  );
}
